import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './@core/home/home.component';
import { ReqformComponent } from './@core/reqform/reqform.component';
import { LoginComponent } from './@core/login/login.component';
import { DeciderComponent } from './@core/decider/decider.component';
import { IndividualformComponent } from './@core/individualform/individualform.component';
import { OrganizeformComponent } from './@core/organizeform/organizeform.component';
import { SubmitpageComponent } from './@core/submitpage/submitpage.component';
import { PlatformComponent } from './@core/platform/platform.component';
import { PlatformLegalComponent } from './@core/platform-legal/platform-legal.component';
import { PlatformLegalOrganizerComponent } from './@core/platform-legal-organizer/platform-legal-organizer.component';
import { ServiceAgreementComponent } from './@core/service-agreement/service-agreement.component';
import { SuccessComponent } from './@core/success/success.component';
import { GstRegistrationComponent } from './@core/gst-registration/gst-registration.component';
import { EventComponent } from './@core/event/event.component';
import { AuthGuard } from './auth.guard';
import { TermsAndConditionsComponent } from './@core/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './@core/privacy-policy/privacy-policy.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  // { path: 'req', component: ReqformComponent },
  { path: 'login', component: LoginComponent, canActivate: [AuthGuard] },
  // { path: 'acctype', component: DeciderComponent },
  { path: 'individual', component: IndividualformComponent, canActivate: [AuthGuard]  },
  { path: 'organiser', component: OrganizeformComponent, canActivate: [AuthGuard]  },
  { path: 'submit', component: SubmitpageComponent, canActivate: [AuthGuard]  },
  { path: 'platform', component: PlatformComponent, canActivate: [AuthGuard]  },
  { path: 'platform-legal', component: PlatformLegalComponent, canActivate: [AuthGuard]  },
  { path: 'platform-legal-organizer', component: PlatformLegalOrganizerComponent, canActivate: [AuthGuard]  },
  { path: 'agreement', component: ServiceAgreementComponent, canActivate: [AuthGuard]  },
  { path: 'event-information', component: EventComponent, canActivate: [AuthGuard]  },
  { path: 'gst-registration', component: GstRegistrationComponent, canActivate: [AuthGuard]  },
  { path: 'success', component: SuccessComponent, canActivate: [AuthGuard]  },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent  },
  { path: 'privacy-policy', component: PrivacyPolicyComponent   },
  { path: '**', redirectTo: 'login' }
  // { path: '', component: HomeComponent },


  // { path: "**", pathMatch: 'full', component: HomeComponent },

  // {
  //   path: '',
  //   component: LayoutComponent,
  //   children: [
  //     { path: '', loadChildren: () => import('./@main/layout.module').then(m => m.LayoutModule) }
  //   ],
  // },


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
